import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

import { PropType, ref, computed, onMounted } from "vue";
  
  import { AvailableProposal, LoanApplication, Vehicle } from "src/types/loan-application/index";
  import CustomerDetailsForm from "./CustomerDetailsForm.vue";
  import CreditCheckForm from "./CreditCheckForm.vue";
  import VehicleDetailsForm from "./VehicleDetailsForm.vue";
  import FinanceDetailsForm from "./FinanceDetailsForm.vue";
  import AddressDetailsForm from "./AddressDetailsForm.vue"
  import EmploymentDetailsForm from "./EmploymentDetailsForm.vue"
  import SummaryDetailsForm from "./SummaryDetailsForm.vue"
  import BankDetailsForm from "./BankDetailsForm.vue"
  import DealerOptionsForm from "./DealerOptionsForm.vue"
  import DealerTermsForm from "./DealerTermsForm.vue"
  import LenderQuoteForm from "./LenderQuoteForm.vue"
  import CustomForm from "./custom-form";

  
export default /*@__PURE__*/_defineComponent({
  __name: 'DealerProposalForm',
  props: {
    proposal: {
      type: Object as PropType<LoanApplication>,
      default: {
        hasDealerAgreedTermsAndConditions: false
      } as LoanApplication
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  setup(__props, { expose: __expose }) {

  const props = __props

  function setVehicle(vehicle: Vehicle) {
    props.proposal.vehicle = vehicle;
  }

  const customerDetailsForm = ref<CustomForm | null>(null);
  const financeDetailsForm = ref<CustomForm | null>(null);
  const vehicleDetailsForm = ref<CustomForm | null>(null);
  const addressDetailsForm = ref<CustomForm | null>(null);
  const employmentDetailsForm = ref<CustomForm | null>(null);
  const bankDetailsForm = ref<CustomForm | null>(null);
  const termsForm = ref<CustomForm | null>(null);

  __expose({ validate });
  function validate() {
    let valid = true;

    customerDetailsForm.value!.validate() ? null : valid = false;
    financeDetailsForm.value!.validate() ? null : valid = false;
    vehicleDetailsForm.value!.validate() ? null : valid = false;
    addressDetailsForm.value!.validate() ? null : valid = false;
    employmentDetailsForm.value!.validate() ? null : valid = false;
    bankDetailsForm.value!.validate() ? null : valid = false;
    termsForm.value!.validate() ? null : valid = false;

    if (!valid) {
      setTimeout(() => {
        const els = document.getElementsByClassName("q-field--error");
        if (els && els.length > 0) {
          els[0].scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 1)
    }
    return valid;
  }

  const score247 = computed(() => {
    let ps = JSON.parse(JSON.stringify(props.proposal.proposals)) as AvailableProposal[];

    if(!ps){
      return 0;
    }

    ps = ps.filter(p => p.loanProposalStatus === "Accepted" ||
      ((p.loanProposalStatus === "ProvisionalAcceptance" ||
      p.loanProposalStatus === "ConditionallyAccepted") &&
      (!p.customerRuleResults || !p.customerRuleResults.find(r => r.resultType === "FixedDecline")))
    )

    if (ps.length === 0) {
      return 0;
    }
    
    const isPrime = ps.find(p => p.isPrime) ? true : false;
    if (isPrime) {
      return 3
    }
    const lowestApr = ps.filter(p => p.apr).length > 0 ? ps.filter(p => p.apr).reduce((prev, curr) => prev.apr! < curr.apr! ? prev : curr) : null;
    const lowestFlat = ps.filter(p => p.flatRate).length > 0 ? ps.filter(p => p.flatRate).reduce((prev, curr) => prev.flatRate! < curr.flatRate! ? prev : curr) : null;

    let lowest = 100;
    if (lowestApr && lowestFlat) {
      lowest = lowestApr.apr! < lowestFlat.flatRate! ? lowestApr.apr! : lowestFlat.flatRate!;
    } else
    if (lowestApr) {
      lowest = lowestApr.apr!
    } else
    if (lowestFlat) {
      lowest = lowestFlat.flatRate!
    }

    return lowest < 29.9 ? 2 : 1
  })

return (_ctx: any,_cache: any) => {
  const _component_q_spinner = _resolveComponent("q-spinner")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (__props.readonly)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 0,
          class: "shadow-5",
          bordered: ""
        }, {
          default: _withCtx(() => [
            (__props.proposal.creditCheck && !__props.proposal.loadingCreditCheck)
              ? (_openBlock(), _createBlock(CreditCheckForm, {
                  key: 0,
                  creditCheck: __props.proposal.creditCheck,
                  score247: score247.value
                }, null, 8, ["creditCheck", "score247"]))
              : (__props.proposal.loadingCreditCheck)
                ? (_openBlock(), _createBlock(_component_q_card, {
                    key: 1,
                    bordered: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_card_section, { class: "text-center" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_q_spinner, { color: "primary" }),
                          _cache[2] || (_cache[2] = _createElementVNode("span", { class: "q-pl-md" }, "Fetching credit report", -1))
                        ]),
                        _: 1,
                        __: [2]
                      })
                    ]),
                    _: 1
                  }))
                : (!__props.proposal.loadingCreditCheck && !__props.proposal.creditCheck)
                  ? (_openBlock(), _createBlock(_component_q_card, {
                      key: 2,
                      bordered: ""
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_q_card_section, { class: "" }, {
                          default: _withCtx(() => _cache[3] || (_cache[3] = [
                            _createElementVNode("span", { class: "" }, "Unable to retrieve credit profile", -1)
                          ])),
                          _: 1,
                          __: [3]
                        })
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.readonly)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 1,
          class: "shadow-5 q-mt-md",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(SummaryDetailsForm, { proposal: __props.proposal }, null, 8, ["proposal"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.proposal.customer)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 2,
          class: "shadow-5 q-mt-md",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(CustomerDetailsForm, {
              modelValue: __props.proposal.customer,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((__props.proposal.customer) = $event)),
              readonly: __props.readonly,
              email: "",
              "email-required": "",
              "mobile-number": "",
              "mobile-number-required": "",
              title: "",
              "title-required": "",
              dob: "",
              "dob-required": "",
              "marital-status": "",
              "marital-status-required": "",
              "driving-licence": "",
              "driving-licence-required": "",
              "monthly-income": "",
              "monthly-income-required": "",
              ref_key: "customerDetailsForm",
              ref: customerDetailsForm
            }, null, 8, ["modelValue", "readonly"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!__props.readonly)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 3,
          class: "shadow-5 q-mt-md",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(VehicleDetailsForm, {
              modelValue: __props.proposal.vehicle,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((__props.proposal.vehicle) = $event)),
              onVehicleFound: setVehicle,
              ref_key: "vehicleDetailsForm",
              ref: vehicleDetailsForm
            }, null, 8, ["modelValue"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_q_card, {
      class: "shadow-5 q-mt-md",
      bordered: ""
    }, {
      default: _withCtx(() => [
        _createVNode(FinanceDetailsForm, {
          proposal: __props.proposal,
          isQuickQuote: false,
          readonly: __props.readonly,
          ref_key: "financeDetailsForm",
          ref: financeDetailsForm
        }, null, 8, ["proposal", "readonly"])
      ]),
      _: 1
    }),
    (__props.proposal.customer)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 4,
          class: "shadow-5 q-mt-md",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(AddressDetailsForm, {
              proposal: __props.proposal,
              readonly: __props.readonly,
              ref_key: "addressDetailsForm",
              ref: addressDetailsForm
            }, null, 8, ["proposal", "readonly"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.proposal.customer)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 5,
          class: "shadow-5 q-mt-md",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(EmploymentDetailsForm, {
              proposal: __props.proposal,
              readonly: __props.readonly,
              ref_key: "employmentDetailsForm",
              ref: employmentDetailsForm
            }, null, 8, ["proposal", "readonly"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!__props.readonly && __props.proposal.customer)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 6,
          class: "shadow-5 q-mt-md",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(BankDetailsForm, {
              customer: __props.proposal.customer,
              ref_key: "bankDetailsForm",
              ref: bankDetailsForm
            }, null, 8, ["customer"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (__props.proposal.lenderQuote)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 7,
          class: "shadow-5 q-mt-md",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(LenderQuoteForm, {
              lenderQuote: __props.proposal.lenderQuote,
              readonly: __props.readonly
            }, null, 8, ["lenderQuote", "readonly"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!__props.readonly)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 8,
          class: "shadow-5 q-mt-md",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(DealerOptionsForm, { proposal: __props.proposal }, null, 8, ["proposal"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!__props.readonly || __props.proposal.hasDealerAgreedTermsAndConditions)
      ? (_openBlock(), _createBlock(_component_q_card, {
          key: 9,
          class: "shadow-5 q-mt-md",
          bordered: ""
        }, {
          default: _withCtx(() => [
            _createVNode(DealerTermsForm, {
              proposal: __props.proposal,
              readonly: __props.readonly,
              ref_key: "termsForm",
              ref: termsForm
            }, null, 8, ["proposal", "readonly"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})